module.exports = __webpack_public_path__ + "img/field.d6b5b320.svg";